import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function   Mumbaitoayodhyacab() {



  const cardData = {
    keyword: " Mumbai to Ayodhya Cab  ",


"headingDescription": "Royal Route Cab offers reliable Mumbai to Ayodhya cab service, providing safe, comfortable, and affordable long-distance travel for families, pilgrims, corporate travelers, and group journeys. The Mumbai to Ayodhya route is a major intercity and spiritual travel corridor covering approximately 1500+ km and connecting Maharashtra with Uttar Pradesh. Our professional drivers and well-maintained vehicles ensure a smooth, secure, and stress-free road journey with proper rest stops and planned travel comfort. We offer flexible options including one-way drops, round trips, and customized pilgrimage packages. Our fleet includes sedans, SUVs, Innova, Ertiga, Innova Crysta, and Tempo Travellers suitable for all group sizes. With transparent pricing, 24/7 availability, and easy booking, Royal Route Cab is your trusted choice for Mumbai to Ayodhya cab service.",

"topPlaces": [
  {
    "title": "Shri Ram Janmabhoomi Temple",
    "description": "Shri Ram Janmabhoomi Temple in Ayodhya is one of the most important religious sites in India, believed to be the birthplace of Lord Shri Ram. The temple is a major pilgrimage destination attracting devotees from across the country and abroad. It is known for its grand architecture, spiritual atmosphere, and deep cultural and historical significance. Pilgrims traveling from Mumbai by cab visit this sacred site for darshan, prayer, and spiritual fulfillment, especially during festivals and special religious occasions."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is a famous temple in Ayodhya dedicated to Lord Hanuman, located on a hill and accessed by climbing steps. It is believed that Lord Hanuman guarded Ayodhya from this place. The temple is highly visited by devotees seeking protection, strength, and blessings before visiting Ram Janmabhoomi. It offers a peaceful spiritual environment and panoramic views of the surrounding city."
  },
  {
    "title": "Saryu River Ghats",
    "description": "The Saryu River Ghats are one of the most peaceful and spiritually significant locations in Ayodhya. Devotees take holy dips in the river and attend the famous evening Saryu Aarti. The ghats are beautifully developed for pilgrims, offering seating areas, walking paths, and devotional ambiance. It is a must-visit place for travelers coming from Mumbai seeking spiritual experience and relaxation."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a beautiful temple dedicated to Lord Ram and Goddess Sita, known for its stunning architecture and richly decorated idols. According to belief, it was gifted to Sita by Queen Kaikeyi after her marriage. The temple is famous for its peaceful environment, intricate design, and strong spiritual importance, making it a key stop for pilgrims visiting Ayodhya."
  },
  {
    "title": "Dashrath Mahal",
    "description": "Dashrath Mahal is believed to be the palace of King Dashrath, father of Lord Ram. It is a significant historical and religious site in Ayodhya showcasing traditional architecture and devotional atmosphere. Visitors often explore this site to understand the ancient Ramayana-era heritage of the city and its cultural roots."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat is a sacred riverside location on the banks of the Saryu River believed to be the place where Lord Ram took Jal Samadhi. It is a peaceful and less crowded ghat ideal for meditation, spiritual reflection, and quiet time by the river. The area is also popular for sunrise and sunset views."
  },
  {
    "title": "Tulsi Smarak Bhawan",
    "description": "Tulsi Smarak Bhawan is dedicated to the great poet Goswami Tulsidas, who wrote the Ramcharitmanas. It serves as a cultural and research center showcasing manuscripts, literature, and exhibitions related to Ramayana. It is an important stop for devotees and history enthusiasts visiting Ayodhya."
  },
  {
    "title": "Ram Ki Paidi",
    "description": "Ram Ki Paidi is a beautifully developed series of ghats on the Saryu River known for cleanliness, lighting, and spiritual atmosphere. It is especially famous during evening Aarti when thousands of lamps illuminate the riverbank. It is a major attraction for tourists and pilgrims visiting Ayodhya."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple is an ancient Shiva temple believed to be established by Kush, son of Lord Ram. It is one of the oldest temples in Ayodhya and holds great religious significance, especially during Shivratri festivals when large crowds gather for worship and rituals."
  },
  {
    "title": "Treta Ke Thakur",
    "description": "Treta Ke Thakur is an important temple believed to mark the place where Lord Ram performed Ashwamedha Yagna. It is open to devotees on specific occasions and is known for its historical and mythological importance in the Ramayana tradition, making it a key spiritual landmark in Ayodhya."
  }
],






services: [
  {
    name: "Mumbai to Ayodhya Cab",
    description: "Mumbai to Ayodhya cab service offers a comfortable and long-distance travel option for devotees and travelers visiting the holy city of Ayodhya. Ideal for religious trips, family journeys, and group travel, this service ensures smooth highway travel with experienced drivers. Well-maintained vehicles provide maximum comfort. It guarantees a safe and peaceful journey."
  },
  {
    name: "Mumbai to Ayodhya Taxi",
    description: "Mumbai to Ayodhya taxi provides private and flexible travel for intercity journeys. This service includes door-to-door pickup and convenient travel schedules. Suitable for long-distance travel with comfort and safety. It ensures a smooth and hassle-free ride."
  },
  {
    name: "Mumbai to Ayodhya Cab Service",
    description: "Mumbai to Ayodhya cab service offers professional travel solutions with multiple vehicle options. This service is ideal for pilgrims, families, and tourists visiting Ayodhya. Clean vehicles and trained drivers enhance comfort. It ensures a reliable and pleasant journey."
  },
  {
    name: "Mumbai to Ayodhya Taxi Service",
    description: "Mumbai to Ayodhya taxi service ensures dependable transportation for long-distance travel. This service is ideal for religious tours and extended trips. Professional chauffeurs and comfortable seating enhance the journey. It guarantees a stress-free experience."
  },
  {
    name: "Cab from Mumbai to Ayodhya",
    description: "Cab from Mumbai to Ayodhya offers a convenient way to travel between cities with complete comfort. This service is ideal for those preferring road travel over flights or trains. Experienced drivers ensure safe journeys. It ensures a relaxed travel experience."
  },
  {
    name: "Taxi from Mumbai to Ayodhya",
    description: "Taxi from Mumbai to Ayodhya provides reliable long-distance travel for individuals and groups. This service ensures smooth highway journeys with professional drivers. Comfortable seating enhances the experience. It guarantees a dependable travel option."
  },
  {
    name: "Mumbai to Ayodhya Cab Booking",
    description: "Mumbai to Ayodhya cab booking allows customers to reserve their ride easily with flexible options. Travelers can choose vehicle type, pickup location, and timing. Instant confirmation ensures availability. It simplifies travel planning."
  },
  {
    name: "Mumbai to Ayodhya Taxi Booking Online",
    description: "Mumbai to Ayodhya taxi booking online provides a quick and convenient way to plan your journey. Customers can compare vehicles and pricing easily. Secure payment and instant confirmation enhance convenience. It ensures hassle-free booking."
  },
  {
    name: "Mumbai to Ayodhya Cab Price",
    description: "Mumbai to Ayodhya cab price varies based on vehicle type, distance, and trip duration. Transparent pricing ensures no hidden charges. Customers can choose from budget and premium options. It helps in planning travel expenses efficiently."
  },
  {
    name: "Mumbai to Ayodhya Taxi Fare",
    description: "Mumbai to Ayodhya taxi fare is designed to be competitive for long-distance travel. Fare depends on route and vehicle selection. Customers receive clear pricing details before booking. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Ayodhya One Way Cab",
    description: "Mumbai to Ayodhya one way cab offers cost-effective travel without return charges. This service is ideal for single-side journeys. Flexible pickup options enhance convenience. It ensures smooth and economical travel."
  },
  {
    name: "Mumbai to Ayodhya Round Trip Taxi",
    description: "Mumbai to Ayodhya round trip taxi provides complete travel solutions including return journeys. This service is ideal for religious tours and extended stays. Flexible schedules and comfortable vehicles enhance convenience. It ensures a hassle-free experience."
  },
  {
    name: "Mumbai to Ayodhya Innova Cab",
    description: "Mumbai to Ayodhya Innova cab is perfect for families and groups seeking spacious and comfortable travel. Premium seating and smooth performance enhance long journeys. It ensures a comfortable pilgrimage experience."
  },
  {
    name: "Mumbai to Ayodhya Ertiga Cab",
    description: "Mumbai to Ayodhya Ertiga cab offers affordable and spacious travel for small groups and families. Comfortable seating and good mileage make it ideal for long-distance journeys. It ensures a pleasant trip."
  },
  {
    name: "Mumbai to Ayodhya Sedan Cab",
    description: "Mumbai to Ayodhya sedan cab is ideal for individuals and small families seeking economical travel. Sedans offer smooth rides and comfort for long journeys. Professional drivers ensure safety. It ensures a relaxed journey."
  },
  {
    name: "Mumbai to Ayodhya SUV Taxi",
    description: "Mumbai to Ayodhya SUV taxi provides spacious and comfortable travel for groups. SUVs offer better performance and extra space for luggage. Suitable for long-distance journeys. It ensures a comfortable travel experience."
  }
],

tableData: [
  ["Mumbai to Ayodhya Cab", "Mumbai to Ayodhya Taxi"],
  ["Mumbai to Ayodhya Cab Service", "Mumbai to Ayodhya Taxi Service"],
  ["Cab from Mumbai to Ayodhya", "Taxi from Mumbai to Ayodhya"],
  ["Mumbai to Ayodhya Cab Booking", "Mumbai to Ayodhya Taxi Booking Online"],
  ["Mumbai to Ayodhya Cab Price", "Mumbai to Ayodhya Taxi Fare"],
  ["Mumbai to Ayodhya One Way Cab", "Mumbai to Ayodhya Round Trip Taxi"],
  ["Mumbai to Ayodhya Innova Cab", "Mumbai to Ayodhya Ertiga Cab"],
  ["Mumbai to Ayodhya Sedan Cab", "Mumbai to Ayodhya SUV Taxi"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Ayodhya Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Ayodhya cab service, ideal for long-distance religious travel and family journeys."
  },
  {
    WhyChooseheading: "Experienced Long-Distance Drivers",
    WhyChoosedescription: "Our drivers are highly experienced in interstate routes, ensuring safe driving, proper navigation, and timely arrival."
  },
  {
    WhyChooseheading: "Perfect for Religious Yatra",
    WhyChoosedescription: "Plan your Ayodhya Ram Mandir darshan with ease using our well-organized cab services for pilgrims and families."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all travel costs with no hidden charges."
  },
  {
    WhyChooseheading: "Flexible One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or multi-day travel plans for Ayodhya trips."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Ayodhya cab service operates 24/7, allowing flexible departure anytime as per your schedule."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, Tempo Travellers, and mini buses for group travel."
  },
  {
    WhyChooseheading: "Trusted Long-Distance Travel Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Ayodhya cab bookings due to reliable service and professional drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Ayodhya cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Ayodhya for one-way and round trips." },
  { question: "What is the distance between Mumbai and Ayodhya?", answer: "The distance is approximately 1400 to 1500 km and takes around 24 to 28 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Ayodhya cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, Tempo Travellers, and mini buses." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Is this suitable for family travel?", answer: "Yes, our service is ideal for family and group pilgrimage travel." },
  { question: "Do you provide interstate travel permits?", answer: "Yes, all required permits are arranged for smooth interstate travel." },
  { question: "Is advance booking required?", answer: "Advance booking is highly recommended for long-distance trips like Ayodhya." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we provide pickup from home, hotel, and office anywhere in Mumbai." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Rakesh Tiwari",
    feedback: "The long journey from Mumbai to Ayodhya with Royal Route Cabs was very comfortable and well-managed. The driver ensured safe driving and regular breaks throughout the trip.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Sunita Verma",
    feedback: "Excellent experience for our Mumbai to Ayodhya pilgrimage trip. The cab was clean, the ride was smooth, and the service felt reliable for such a long journey.",
    rating: 5
  }
];










  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];






const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Ayodhya Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-ayodhya-cab.jpg", // replace if needed
  "description": "Book Mumbai to Ayodhya cab service with Royal Route Cabs for safe, reliable, and comfortable long-distance travel. Available for one-way and round-trip journeys with sedan, SUV, Innova, and Ertiga vehicles. 24x7 intercity taxi service for pilgrimage travel.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "18", // per km approx starting (adjust if needed)
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-ayodhya-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Ayodhya Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Ayodhya cab with Royal Route Cabs. Safe and comfortable long-distance pilgrimage taxi service with affordable fares, expert drivers, and 24x7 availability."
  />

  <meta
    name="keywords"
    content="mumbai to ayodhya cab, mumbai to ayodhya taxi, mumbai to ayodhya cab service, mumbai to ayodhya taxi service, cab from mumbai to ayodhya, taxi from mumbai to ayodhya, mumbai to ayodhya cab booking, mumbai to ayodhya taxi booking online, mumbai to ayodhya cab price, mumbai to ayodhya taxi fare, mumbai to ayodhya one way cab, mumbai to ayodhya round trip taxi, mumbai to ayodhya innova cab, mumbai to ayodhya ertiga cab, mumbai to ayodhya sedan cab, mumbai to ayodhya suv taxi"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/53.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitoayodhyacab;